import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import { MultiSelect } from 'primereact/multiselect';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import { useCatchResponse } from '../../../utils/useCatchResponse';
import Toast from '../../Shared/Toast/Toast';

const TemplateValues = (props) => {
    const { catchResponse } = useCatchResponse();
    const { onSave, editData, totalOfList, bestOfList, allList, totalBestOfData } = props;
    const [securityUserID, setSecurityUserID] = useState("");
    const [examTypeList, setExamTypeList] = useState([]);
    const [examType, setExamType] = useState('Individual');
    const [examName, setExamName] = useState('');
    const [examNameErr, setExamNameErr] = useState(false);
    const [examNameErrText, setExamNameErrText] = useState('');
    const [shortName, setShortName] = useState('');
    const [totalMarks, setTotalMarks] = useState('');
    const [minMarks, setMinMarks] = useState('');
    const [minMarksErr, setMinMarksErr] = useState(false);
    const [minMarksErrText, setMinMarksErrText] = useState('');
    const [term, setTerm] = useState([]);
    const [totalValueList, setTotalValueList] = useState([]);
    const [totalValue, setTotalValue] = useState([]);
    const [bestOfValueList, setBestOfValueList] = useState([]);
    const [reExamValueList, setReExamValueList] = useState([]);
    const [bestOfValue, setBestOfValue] = useState([]);
    const [termsList, setTermsList] = useState([]);
    const [templateValueId, setTemplateValueId] = useState('');
    const [isOverAllAllow, setIsOverAllAllow] = useState(false);
    const [isGradeAllow, setIsGradeAllow] = useState(false);
    const [isPractiseTest, setIsPractiseTest] = useState(false);
    const [reExamType, setReExamType] = useState([]);
    const [reExamTypeErr, setReExamTypeErr] = useState(false);
    const [reExamTypeErrText, setReExamTypeErrText] = useState('');
    const [bestOfValueErrText, setBestOfValueErrText] = useState('');
    const [bestOfValueErr, setBestOfValueErr] = useState(false);


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        const totalOfData = [{
            Value: '',
            Weightage: ''
        }];
        setSecurityUserID(loginData?._id);
        GetTermsList(loginData?._id);
        GetExamTypeList(loginData?._id);

        const mappedTotalList = totalOfList?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id,
        })) || [];

        const mappedBestOfList = bestOfList?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];

         const mappedReExamList = bestOfList?.map(x => ({
            ...x,
            label: x?.Name,
            value: x?._id
        })) || [];

        const mappedTotalBestOfList = totalBestOfData?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];

        const usedInTotalSet = new Set(
            allList
                .filter(x =>
                    (x?.ExamType === 'Total' || x?.ExamType === 'Best Of') &&
                    (!editData || x?._id !== editData?._id)
                )
                .flatMap(x => (x?.TotalValue || []).map(v => v?.Value))
        );

        const filteredBestOfList = allList.filter(x =>
            (x?.ExamType === 'Individual' || x?.ExamType === 'Total' || x?.ExamType === 'Best Of') &&
            !usedInTotalSet.has(x?._id)
        );

        const totalDataList = filteredBestOfList?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];

        const totalBestOfList =
            editData?.IsOverAllAllow
                ? totalDataList
                : [...mappedBestOfList, ...mappedTotalList, ...mappedTotalBestOfList];


        setTotalValueList(totalBestOfList);
        setBestOfValueList(mappedBestOfList);
        setReExamValueList(mappedReExamList);

        if (editData) {
            const valueData = totalBestOfList?.filter(x => x?.value !== editData?._id);
            setTotalValueList(valueData);
            setTemplateValueId(editData?._id);
            setExamType(editData?.ExamType);
            setExamName(editData?.Name);
            setIsOverAllAllow(editData?.IsOverAllAllow);
            setIsGradeAllow(editData?.IsGradeAllow);
            setIsPractiseTest(editData?.IsPractiseTest);
            setShortName(editData?.ShortName);
            setTotalMarks(editData?.Marks);
            setMinMarks(editData?.MinMarks);
            setTerm(editData?.Term ? editData?.Term.split(',') : []);
            setBestOfValue(editData?.BestOfValue ? editData?.BestOfValue.split(',') : []);
            setReExamType(editData?.ReExamType ? editData?.ReExamType : '');

            const totalValueData = editData?.TotalValue?.map(x => {
                const match = totalBestOfList?.find(z => z?.value === x?.Value);
                return {
                    ...x,
                    id: Date.now(),
                    MinMarks: match?.MinMarks || x?.MinMarks,
                    Marks: match?.Marks || x?.Marks
                };
            }) || totalOfData;

            setTotalValue(totalValueData);
        } else {
            setTotalValue(totalOfData);
        }
    }, [editData, totalOfList, bestOfList]);

    const GetExamTypeList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getExamTypeList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setExamTypeList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetTermsList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getTermList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setTermsList(res?.data?.map(x => ({
                        label: x?.TermName,
                        value: x?._id,
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const handleOverAllow = (value) => {
        setIsOverAllAllow(value);
        const mappedTotalList = totalOfList?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id,
        })) || [];

        const mappedBestOfList = bestOfList?.map(x => ({
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];

        const mappedTotalBestOfList = totalBestOfData?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];


        const usedInTotalSet = new Set(
            allList
                .filter(x => x?.ExamType === 'Total' || x?.ExamType === 'Best Of')
                .flatMap(x => (x?.TotalValue || []).map(v => v?.Value))
        );
        const filteredBestOfList = allList.filter(x =>
            (x?.ExamType === 'Individual' || x?.ExamType === 'Total' || x?.ExamType == 'Best Of') &&
            !usedInTotalSet.has(x?._id)
        );

        const totalDataList = filteredBestOfList?.map(x => ({
            ...x,
            label: `${x?.Name} (${x?.TermName})`,
            value: x?._id
        })) || [];

        const totalBestOfList =
            value
                ? totalDataList
                : [...mappedBestOfList, ...mappedTotalList, ...mappedTotalBestOfList];

        setTotalValueList(totalBestOfList);
    }

    const handleChange = (e, type) => {
        const value = e.target.value;
        const multiLangValue = value.replace(/[^a-zA-Z0-9\s!.-@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        if (type === 'ExamName') {
            setExamName(multiLangValue);
        } else if (type === 'ShortName') {
            setShortName(multiLangValue);
        } else if (type === 'TotalMarks') {
            setTotalMarks(numericValue);
            if (minMarks && parseInt(minMarks) >= parseInt(numericValue)) {
                setMinMarks('');
            }
        } else if (type === 'MinMarks') {
            if (parseInt(numericValue) >= parseInt(totalMarks)) {
                setMinMarksErr(true);
                setMinMarksErrText('Min Marks should be less than Total Marks');
                return;
            }
            setMinMarksErr(false);
            setMinMarksErrText('');
            setMinMarks(numericValue);
        }
    };

    const AddTemplateValue = () => {
        if (CommonConfig.isEmpty(examName)) {
            setExamNameErr(true);
            setExamNameErrText('Exam is Required');
            return;
        }

        if (examType === 'Re-Exam') {

            if (reExamType?.length === 0) {
                setReExamTypeErr(true);
                setReExamTypeErrText('Re-exam type is Required');
                return;
            }
            const termNames = termsList
                .filter(x => term.includes(x?.value))
                .map(x => x.label);

            const reExamTypeName = reExamValueList?.find(x => x?.value == reExamType);

            onSave({
                _id: templateValueId,
                ExamType: examType,
                Name: examName,
                ShortName: '',
                Marks: '',
                MinMarks: '',
                Term: term ? term?.join(',') : '',
                BestOfValue: '',
                BestOfValueName: '',
                TermName: termNames?.join(', '),
                TotalValue: [],
                TotalValueName: '',
                Weightage: '-',
                IsOverAllAllow: isOverAllAllow,
                IsGradeAllow: isGradeAllow,
                IsPractiseTest: isPractiseTest,
                ReExamTypeName: reExamTypeName ? reExamTypeName?.Name : '',
                ReExamType: reExamType ? reExamType : '',
            });
            return;
        }

        if (examType === 'Best Of') {
            const selectedItems = bestOfValueList.filter(item =>
                bestOfValue.includes(item.value)
            );

            if (selectedItems.length > 1) {
                const firstMarks = Number(selectedItems[0]?.Marks);

                const allMarksSame = selectedItems.every(item =>
                    Number(item?.Marks) === firstMarks
                );

                if (!allMarksSame) {
                    setBestOfValueErr(true);
                    setBestOfValueErrText('All selected Best Of exams must have same Marks.');
                    return;
                }
            }
        }
        const termNames = termsList
            .filter(x => term.includes(x?.value))
            .map(x => x.label);

        const valueMap = Object.fromEntries(
            totalValueList.map(item => [item?.value, item?.Name])
        );

        const totalOfName = totalValue
            ? totalValue.map(x => valueMap[x?.Value]).filter(Boolean).join(", ")
            : "";

        const valueBestMap = Object.fromEntries(
            bestOfValueList.map(item => [item?.value, item?.Name])
        );

        const bestOfName = bestOfValue
            ? bestOfValue.map(x => valueBestMap[x]).filter(Boolean).join(", ")
            : "";

        const weightage = totalValue ?
            totalValue?.map(x => x?.Weightage) : '';

        onSave({
            _id: templateValueId,
            ExamType: examType,
            Name: examName,
            ShortName: shortName,
            Marks: totalMarks,
            MinMarks: minMarks,
            Term: term ? term?.join(',') : '',
            BestOfValue: bestOfValue ? bestOfValue?.join(',') : '',
            BestOfValueName: bestOfName,
            TermName: termNames?.join(', '),
            TotalValue: totalValue || [],
            TotalValueName: totalOfName,
            Weightage: weightage ? weightage?.join(', ') : '-',
            IsOverAllAllow: isOverAllAllow,
            IsGradeAllow: isGradeAllow,
            IsPractiseTest: isPractiseTest,
            ReExamType: reExamType ? reExamType : '',
        });

    };

    const onCancel = () => {
        setExamName('');
        setExamType('');
        setTotalMarks('');
        setShortName('');
        setTerm('');
        setBestOfValue([]);
        setTotalValue([]);
        setTemplateValueId('');
        props.onCancel();
    };

    const totalValueBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div>
                <div className="">
                    <Dropdown
                        id={`Value-${rowIndex}`}
                        value={rowData?.Value}
                        style={{ width: '240px' }}
                        options={totalValueList?.filter(y => y?.Name !== examName)}
                        onChange={(e) => handleTemplateValuesChange(rowIndex, 'Value', e.value)}
                        placeholder="Select"
                        display="chip"
                        className=' p-mt-1'
                        filter
                        showClear
                    />
                </div>
            </div>
        )
    };

    const weightageBodyTemplate = (rowData, { rowIndex }) => {
        return (
            <div>
                <div className="custom-inputs">
                    <InputText
                        className="p-mt-1"
                        style={{ width: '100px' }}
                        id={`Weightage-${rowIndex}`}
                        type="text"
                        maxLength={3}
                        value={rowData?.Weightage}
                        onChange={(e) => handleTemplateValuesChange(rowIndex, 'Weightage', e.target.value)}
                    />
                </div>
            </div>
        )
    };

    const actionsBodyTemplate = (rowData, { rowIndex }) => (
        <div className="p-d-flex p-ai-center">
            {rowIndex === totalValue.length - 1 &&
                <Button
                    icon="pi pi-plus"
                    className="e-sction-btn p-m-0 p-mt-3"
                    onClick={() => addTemplateValue()}
                />}
            {(rowIndex !== 0 || totalValue.length > 1) &&
                <Button icon="pi pi-trash" className="e-sction-btn p-m-0 p-mt-3 p-ml-lg-1"
                    onClick={() => removeTemplateValue(rowIndex)}
                />
            }
        </div>
    );

    const addTemplateValue = () => {
        let values = [{
            'id': Date.now(),
            'Value': '',
            'Weightage': ''
        }];
        setTotalValue([...totalValue, ...values]);
    };

    const removeTemplateValue = (index) => {
        const updatedTemplates = totalValue?.filter((_, i) => i !== index);
        setTotalValue(updatedTemplates);
    };

    const handleTemplateValuesChange = (index, key, value) => {

        setTotalValue((prev) => {

            const updatedTemplateValues = [...prev];
            const row = { ...updatedTemplateValues[index] };

            if (key === "Value") {
                row[key] = value;

                const filterdata = totalValueList.find(x => x?.value === value);

                row.Marks = filterdata?.Marks || "";
                row.MinMarks = filterdata?.MinMarks || "";

            } else {

                const numericValue = value.replace(/[^0-9]/g, "");
                row[key] = numericValue;

            }

            updatedTemplateValues[index] = row;

            const total = updatedTemplateValues.reduce((acc, curr) => {

                const marks = parseFloat(curr?.Marks) || 0;
                const weight = parseFloat(curr?.Weightage) || 0;

                return acc + (marks * weight) / 100;

            }, 0);

            setTotalMarks(total.toFixed(2));

            return updatedTemplateValues;
        });
    };

    return (
        <div className='p-d-flex flex-column p-jc-between p-h-100'>
            <div className='e-template-value-table'>
                <div className='p-grid'>
                    {examTypeList?.map((tab) => (
                        <div className="p-col-12 p-md-3">
                            <div className="">
                                <RadioButton
                                    inputId={tab?._id}
                                    name={tab?._id}
                                    value={tab?.ExamTypeName}
                                    checked={examType === tab?.ExamTypeName}
                                    onChange={(e) => setExamType(e.value)}
                                    disabled={CommonConfig.isEmpty(templateValueId) ? false : true}
                                />
                                <label htmlFor="Activity" className='p-ml-1'> {tab?.ExamTypeName}</label>
                            </div>
                        </div>
                    ))}
                    {examType === 'Total' && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <div className="custom-inputs">
                                <label htmlFor="isOverAllAllow" className='p-d-block'>Over All Allow</label>
                                <Checkbox
                                    className='p-ml-2 p-mt-1'
                                    inputId="isOverAllAllow"
                                    checked={isOverAllAllow}
                                    onChange={(e) => {
                                        handleOverAllow(e.checked)
                                    }}
                                />
                            </div>
                        </div>
                    </div>}
                    {examType === 'Individual' && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <div className="custom-inputs">
                                <label htmlFor="isPractiseTest" className='p-d-block'>Practise Test</label>
                                <Checkbox
                                    className='p-ml-2 p-mt-1'
                                    inputId="isPractiseTest"
                                    checked={isPractiseTest}
                                    onChange={(e) => setIsPractiseTest(e.checked)}
                                />
                            </div>
                        </div>
                    </div>}
                    {(examType === 'Total' || examType === 'Individual') && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <div className="custom-inputs">
                                <label htmlFor="isGradeAllow" className='p-d-block'>Grade Allow</label>
                                <Checkbox
                                    className='p-ml-2 p-mt-1'
                                    inputId="isGradeAllow"
                                    checked={isGradeAllow}
                                    onChange={(e) => {
                                        setIsGradeAllow(e.checked)
                                    }}
                                />
                            </div>
                        </div>
                    </div>}

                    <div className="p-col-12 p-md-6 p-pt-2">
                        <label htmlFor="examName">Exam Name<span style={{ color: "red" }}>*</span></label>
                        <div className="custom-inputs">
                            <FloatLabel>
                                <InputText
                                    className="p-pl-2 p-w-100 p-mt-1"
                                    id="examName"
                                    maxLength={40}
                                    placeholder="ExamName"
                                    value={examName}
                                    autoFocus={true}
                                    onChange={(e) => handleChange(e, 'ExamName')}
                                />
                            </FloatLabel>
                            <span className="error-msg" style={{ color: 'red' }}>
                                {examNameErr ? examNameErrText : null}
                            </span>
                        </div>
                    </div>
                    {examType !== 'Re-Exam' &&
                        (<>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="shortName">Short Name</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="shortName"
                                            maxLength={20}
                                            placeholder="Short Name"
                                            value={shortName}
                                            onChange={(e) => handleChange(e, 'ShortName')}
                                        />
                                    </FloatLabel>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="totalMarks">Total Marks</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="totalMarks"
                                            maxLength={3}
                                            placeholder="Total Marks"
                                            value={totalMarks}
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e, 'TotalMarks')}
                                        />
                                    </FloatLabel>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6 p-pt-2">
                                <label htmlFor="minMarks">Min Marks</label>
                                <div className="custom-inputs">
                                    <FloatLabel>
                                        <InputText
                                            className="p-pl-2 p-w-100 p-mt-1"
                                            id="minMarks"
                                            maxLength={3}
                                            placeholder="Min Marks"
                                            value={minMarks}
                                            autoFocus={true}
                                            onChange={(e) => handleChange(e, 'MinMarks')}
                                        />
                                    </FloatLabel>
                                    <span className="error-msg" style={{ color: 'red' }}>
                                        {minMarksErr ? minMarksErrText : null}
                                    </span>
                                </div>
                            </div>
                        </>)}
                    {(!isOverAllAllow) && <div className="p-col-12 p-md-6 p-pt-2">
                        <div className="">
                            <label htmlFor="term">Terms</label>
                            <div className="custom-inputs">
                                <MultiSelect
                                    id="term"
                                    value={term}
                                    options={termsList}
                                    onChange={(e) => setTerm(e.value)}
                                    placeholder="Select Terms"
                                    display="chip"
                                    className='p-w-100 p-mt-1'
                                    filter
                                />
                            </div>
                        </div>
                    </div>}
                    {examType === 'Total' &&
                        <div className='p-w-100 p-col-12 p-md-6 p-pt-2'>
                            <DataTable value={totalValue} dataKey="id" responsiveLayout="scroll" key={JSON.stringify(totalValueList)} className='custom-table e-tamplate-table p-w-100' scrollHeight='calc(100vh - 600px)' size='small'>
                                <Column header="Total" body={totalValueBodyTemplate} style={{ maxWidth: '280px', width: '280px' }} />
                                <Column header="Weightage" body={weightageBodyTemplate} style={{ maxWidth: '180px', width: '180px' }} />
                                <Column header="Marks" field='Marks' headerClassName='e-template-marks' />
                                <Column header="Min Marks" field='MinMarks' headerClassName='e-template-marks' />
                                <Column header="Actions" body={actionsBodyTemplate} headerStyle={{ width: '100%' }} headerClassName='e-template-action' bodyClassName='e-template-action' />
                            </DataTable>
                        </div>
                    }
                    {examType === 'Best Of' &&
                        <div className="p-col-12 p-md-6 p-pt-2">
                            <div className="custom-inputs">
                                <label htmlFor="bestOfValue">Best Of</label>
                                <div className="custom-inputs">
                                    <MultiSelect
                                        id="bestOfValue"
                                        value={bestOfValue}
                                        options={bestOfValueList}
                                        onChange={(e) => setBestOfValue(e.value)}
                                        placeholder="Select Best Of"
                                        display="chip"
                                        className='p-w-100 p-mt-1'
                                        filter
                                    />
                                    <span className="error-msg" style={{ color: 'red' }}>
                                        {bestOfValueErr ? bestOfValueErrText : null}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                    {examType === 'Re-Exam' &&
                        <div className="p-col-12 p-md-6 p-pt-2">
                            <div className="custom-inputs">
                                <label htmlFor="reExamValue">Exam type</label>
                                <div className="custom-inputs">
                                    <Dropdown
                                        id='reExam'
                                        value={reExamType}
                                        options={reExamValueList}
                                        onChange={(e) => setReExamType(e.value)}
                                        placeholder="Select Exam Type"
                                        display="chip"
                                        className='p-w-100 p-mt-1'
                                        filter
                                        showClear
                                    />
                                    <span className="error-msg" style={{ color: 'red' }}>
                                        {reExamTypeErr ? reExamTypeErrText : null}
                                    </span>
                                </div>
                            </div>
                        </div>
                    }
                </div>

            </div>
            <div className="dialog-footer p-d-flex p-ai-center p-jc-end p-mb-2">
                <Button className='p-m-0 btn-text-action-secondary p-m-1' label="Cancel" onClick={(e) => onCancel()} />
                <Button className='p-m-0 btn-text-action-primary' label="Add" onClick={(e) => AddTemplateValue()} />
            </div>
        </div >
    );
};

export default TemplateValues;
